import request from '@/utils/request'

export function shopLogin (data) {
  return request({
    url: '/system/login/shopLogin',
    method: 'POST',
    data
  })
}

export function managementLogin (data) {
  return request({
    url: '/system/login/managementLogin',
    method: 'POST',
    data
  })
}

export function journeyLogin (data) {
  return request({
    url: '/system/login/journeyUserLogin',
    method: 'POST',
    data
  })
}

export function login (data, loginType) {
  if (loginType === 'shop') {
    return shopLogin(data)
  }
  if (loginType === 'journey') {
    return journeyLogin(data)
  }
  return managementLogin(data)
}



// WEBPACK FOOTER //
// ./src/api/login.js